import {Component, Input, OnInit} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '../icons-svgs/icons-svgs.component';

@Component({
    selector: 'app-lf-advantages',
    templateUrl: './lf-advantages.component.html',
    styleUrls: ['./lf-advantages.component.scss'],
    standalone: true,
    imports: [IconComponent, TranslateModule]
})
export class LfAdvantagesComponent implements OnInit {

  @Input() public iconName: string;
  @Input() public title: string;
  @Input() public text: string;

  constructor() {
  }

  ngOnInit(): void {
  }

}
